const Hero = () => {
  return (
    <div className="hero">
      <h1>A simple Bookmark Manager</h1>
      <p>A clean and simple interface to organize your favourite websites. Open a new browser tab and see your sites load instantly. Try it for free.</p>
      <button className="chrome">Get it on Chrome</button>
      <button className="firefox">Get it on Firefox</button>
    </div>
  )
}

export default Hero